import { render } from "./ImportConsultants.vue?vue&type=template&id=00286eef"
import script from "./ImportConsultants.vue?vue&type=script&lang=js"
export * from "./ImportConsultants.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__